import React, {Component} from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import {GroupModules} from 'Frontend/components/modules';

import {clampCss, pxToVw} from 'Frontend/utils/helpers';
import {MEDIA} from 'Frontend/utils/mediaQueries';

/**
 * ModuleGroup
 *
 * @property {*} prop Prop comment.
 *
 * @class ModuleGroup
 * @extends {Component}
 */
class ModuleGroup extends Component {
    static propTypes = {group: PropTypes.array.isRequired}

    /**
     * Renders the Component.
     *
     * @returns {JSX} Component.
     * @memberof ModuleGroup
     */
    render() {
        const {group} = this.props;

        return (
            <ModuleGroupElement>
                <GroupHead />
                <GroupContainer>
                    {group.map(module => {
                        if (GroupModules[module.type]) {
                            const Comp = GroupModules[module.type];

                            // eslint-disable-next-line react/jsx-props-no-spreading
                            return <Comp key={module.name} {...module} isInGroup />;
                        }

                        return null;
                    })}
                </GroupContainer>
                <GroupBottom />
            </ModuleGroupElement>
        );
    }
}

export default ModuleGroup;

const ModuleGroupElement = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: ${clampCss(-32, 'm', true)};
    margin-top: ${clampCss(96, 'm')};

    &:last-child {
        margin-bottom: ${clampCss(96, 'm')};
    }

    ${MEDIA.TABLET.UP} {
        margin-bottom: ${clampCss(-30, 't', true)};
        margin-top: ${clampCss(142, 't')};

        &:last-child {
            margin-bottom: ${clampCss(142, 't')};
        }
    }

    ${MEDIA.DESKTOP.UP} {
        margin-bottom: max(${pxToVw(-44, 'd')}, -44px);
        margin-top: max(224px, ${pxToVw(224, 'd')});

        &:last-child {
            margin-bottom: max(224px, ${pxToVw(224, 'd')});
        }
    }
`;

const GroupHead = styled.div`
    background: linear-gradient(to bottom right, #fff 0%, #fff 49.5%, #FAF6F4 50%, #FAF6F4 100%);
    height: ${clampCss(32, 'm')};
    width: 100%;

    ${MEDIA.TABLET.UP} {
        height: ${clampCss(64, 't')};
    }

    ${MEDIA.DESKTOP.UP} {
        height: max(95px, ${pxToVw(95, 'd')});
        margin: 0 max(125.5px, ${pxToVw(125.5, 'd')}) 0 max(125.5px, ${pxToVw(125.5, 'd')});
        max-width: max(1069px, ${pxToVw(1069, 'd')});
        width: calc(100% - max(251px, ${pxToVw(251, 'd')}));
    }
`;

const GroupContainer = styled.div`
    background-color: #FAF6F4;
    padding: ${clampCss(94, 'm')} 0 0 0;
    width: 100%;

    ${MEDIA.TABLET.UP} {
        padding: ${clampCss(41, 't')} 0 0 0;
    }

    ${MEDIA.DESKTOP.UP} {
        margin: 0 max(125.5px, ${pxToVw(125.5, 'd')}) 0 max(125.5px, ${pxToVw(125.5, 'd')});
        max-width: max(1069px, ${pxToVw(1069, 'd')});
        padding: max(41px, ${pxToVw(41, 'd')}) 0 0 0;
        width: calc(100% - max(251px, ${pxToVw(251, 'd')}));
    }
`;

const GroupBottom = styled.div`
    background: linear-gradient(to top left, #fff 0%, #fff 49.5%, #FAF6F4 50%, #FAF6F4 100%);
    height: ${clampCss(32, 'm')};
    width: 100%;

    ${MEDIA.TABLET.UP} {
        height: ${clampCss(64, 't')};
    }

    ${MEDIA.DESKTOP.UP} {
        height: max(95px, ${pxToVw(95, 'd')});
        margin: 0 max(125.5px, ${pxToVw(125.5, 'd')}) 0 max(125.5px, ${pxToVw(125.5, 'd')});
        max-width: max(1069px, ${pxToVw(1069, 'd')});
        width: calc(100% - max(251px, ${pxToVw(251, 'd')}));
    }
`;